export default __webpack_public_path__ + "static/media/icon-email-accept.b0282d87.svg";